import { bootstrapApplication } from '@angular/platform-browser';
import * as Sentry from '@sentry/angular';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { environment } from './environments';

// Error tracking (observability Phase 4) — reports uncaught errors and a light sample of route
// transitions to GlitchTip. `enabled` is false whenever sentryDsn is empty (local dev with no
// GlitchTip running), so this is a silent no-op until a real DSN is configured for that environment.
Sentry.init({
  dsn: environment.sentryDsn || undefined,
  enabled: !!environment.sentryDsn,
  environment: environment.production ? 'production' : 'development',
  release: `${environment.appName}@1.0.0`,
  integrations: [Sentry.browserTracingIntegration()],
  tracesSampleRate: 0.1,
  sendDefaultPii: false,
});

bootstrapApplication(App, appConfig)
  .catch((err) => console.error(err));
